<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="basketCodeValue"
                            label="Sepet Kodu"
                            filled
                            solo
                            dense
                            clearable
                        ></v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="definitionValue"
                            label="Tanım"
                            filled
                            solo
                            dense
                            clearable
                        ></v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="categoryValue"
                            label="Kategori"
                            filled
                            solo
                            dense
                            clearable
                            :items="basketCategoryList"
                            item-value="id"
                            item-text="name"
                        ></v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="categoryValue"
                            label="Durum"
                            filled
                            solo
                            dense
                            clearable
                            :items="[{value:1,text:'Başarılı'},{value:2,text:'Başarısız'}]"
                            item-value="value"
                            item-text="text"
                        ></v-select>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                            @click="_fetchBasketList"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10 </v-btn>
                <v-btn @click="perPage = 20"> 20 </v-btn>
                <v-btn @click="perPage = 30"> 30 </v-btn>
                <v-btn @click="perPage = 50"> 50 </v-btn>
              </v-btn-toggle>
            </div>
            <div class="ms-auto">
              <v-btn v-if="this.user.RoleGroupId === 1 || this.user.RoleGroupId === '1'" small color="success darken-1" @click="openNewBasketDialog">Sepet Oluştur</v-btn>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b></b> Kayıt Bulundu</p>
          <ResultTableView :perPage="perPage"></ResultTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="1"
                :total-visible="20"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>
    <NewBasketDialog
        :showDialog="showNewBasketDialog"
        :processType="'new'"
        @dialogChange="(e) => (showNewBasketDialog = e)"
    ></NewBasketDialog>
  </div>

</template>

<script>
import ResultTableView from "@/components/campaign/basket/results/ResultsTableView";
import {formattedDate} from "@/momentHelper";
import { mapState, mapActions } from "vuex";
import NewBasketDialog from "@/components/campaign/basket/dialogs/NewBasketDialog";

export default {
  components: {
    ResultTableView,
    NewBasketDialog
  },
  props:{
    listType:{
      type: String,
      default: "SiparisList"
    }
  },
  mounted() {
    //this.getOrders(this.listType);
    this._fetchBasketCategoryList();
    this._fetchBasketList();
  },
  computed: {
    ...mapState("basket",["basketCategoryList"]),
    ...mapState("cart",["current"]),
    ...mapState("auth",["user"])
  },
  data() {
    return {

      perPage: 10,
      currentPage: 1,
      dateRangeStart: null,
      dateRangeEnd: null,
      basketCodeValue: null,
      definitionValue: null,
      categoryValue: null,
      showNewBasketDialog: false
    };
  },
  methods: {
    formattedDate,
    ...mapActions("basket", ["fetchBasketCategoryList","fetchBasketList"]),
    _fetchBasketCategoryList(){
      this.fetchBasketCategoryList({
        params:{},
        body:{}
      });
    },
    _fetchBasketList(){
      this.fetchBasketList({
        params:{
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          userId: this.user.UserId,
          ...(this.current) && {currentCode: this.current.code}
        },
        body:{
          BasketCode: this.basketCodeValue,
          Definition: this.definitionValue,
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          CategoryId: this.categoryValue,
          isActive: true
        }
      });
    },
    openNewBasketDialog(){
      this.showNewBasketDialog = true;
    }
  },
  watch:{
    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
      this._fetchBasketCategoryList();
    },

    currentPage: function (newVal) {
      newVal;
      this._fetchBasketCategoryList();
    }
  }
};
</script>